module.exports = new __parcel__URL__("machines_plasma_mortar_level_3.7fc04028.png").toString();